import types from "../../../constants/action-types"
const years = (value) => {
  const year = new Date().getFullYear()
  return Array.from({ length: value }, (v, i) => ({
    _id: year - value + i + 1,
    title: year - value + i + 1,
  }))
}

const defaultState = {
  groupId: null,
  tableIndex: null,
  groupTitle: ",",
  categories: [],
  groups: [],
  regions: [],
  filters: {},
  loading: false,
  activeItem: "all",
  years: years(10),
}

const map = {
  [types.APPLICATION_SET_group_ID]: (state, { payload }) => ({
    ...state,
    groupId: payload.groupId,
    tableIndex: payload.index,
    groupTitle: payload.title,
  }),

  [types.APPLICATION_ACTIVE_ITEM]: (state, { payload }) => ({
    ...state,
    activeItem: payload,
  }),
  [types.APPLICATION_SET_CATEGORIES]: (state, { payload }) => ({
    ...state,
    categories: payload,
  }),
  [types.APPLICATION_SET_REGIONS]: (state, { payload }) => ({
    ...state,
    regions: payload,
  }),

  [types.APPLICATION_SET_groupS]: (state, { payload }) => ({
    ...state,
    groups: payload,
  }),

  [types.APPLICATION_SET_FILTERS]: (state, { payload }) => ({
    ...state,
    filters: { ...payload },
  }),
  [types.APPLICATION_CLEAR_FILTERS]: (state) => ({
    ...state,
    filters: {},
  }),
  [types.APPLICATION_SET_LOADING]: (state, { payload }) => ({
    ...state,
    loading: payload,
  }),
}

export default (state, action) =>
  (map[action.type] && map[action.type](state, action)) || state || defaultState
